import React from 'react';
import { IconButton } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import CloseIcon from '@mui/icons-material/CloseRounded';

const styles = theme => ({
    button: {
        float: 'right',
        marginTop: -12,
        marginRight: -20,
        padding: theme.spacing(1) / 2,
        [theme.breakpoints.down('xl')]: {
            height: '40px'
        }
    },
});

class DialogCloseButton extends React.Component {
    render() {
        const { classes, onClick } = this.props

        return (
            <IconButton
                className={classes.button}
                aria-label='close'
                onClick={onClick}
                size="large"
            >
                <CloseIcon />
            </IconButton>
        );
    }
}

export default withStyles(DialogCloseButton, styles);